import React from 'react';
import CompanyInformationTabs from 'src/features/siva/ideas-and-companies/company-details/components/CompanyInformationTabs';
import CompanyBaseInfoBox from 'src/features/siva/ideas-and-companies/components/company/CompanyBaseInfoBox';
import { useExternalCompany } from 'src/hooks/use-external-company';
import useOneWayIn from '../../hooks/use-one-way-in';
import { PageParams } from '../types/PageParams';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useOrgInfo from '../hooks/use-org-info';
import { Link } from '@innovationnorway/cl-react';

const OldCompanyInfo = () => {
  const { formId } = useParams<PageParams>();
  const { oneWayInOpportunityById } = useOneWayIn(formId);
  const { data: company } = useExternalCompany(oneWayInOpportunityById.data?.organizationNumber ?? '');
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const { organizationNumber } = useOrgInfo(formId || '');

  return (
    <>
      <h2>{tOneWayIn('details.Title.CompanyInfo')}</h2>
      <CompanyBaseInfoBox company={company} />
      <Link href={`/resource-base/members/${oneWayInOpportunityById.data?.clusterMemberId}`}>
        Vis i kunderegister
      </Link>
      <br />
      <CompanyInformationTabs
        clusterMemberId={oneWayInOpportunityById.data?.clusterMemberId ?? ''}
        organizationNumber={organizationNumber ?? ''}
        hideNaceWarning
      />
    </>
  );
};

export default OldCompanyInfo;
